import { render } from "./SavedPosts.vue?vue&type=template&id=eb9d1eaa&scoped=true"
import script from "./SavedPosts.vue?vue&type=script&lang=js"
export * from "./SavedPosts.vue?vue&type=script&lang=js"

import "./SavedPosts.vue?vue&type=style&index=0&id=eb9d1eaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb9d1eaa"]])

export default __exports__